import React, { useCallback } from 'react';
import { Space, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setThresholdDisabledStatus } from '@store/noc/threshold/actions';
import { ToggleText, Header } from '@components/summary-panel/SummaryContainer/Options/styled';
import featureNames from '@utils/featureToggle/constants';
import { selector as commonSelector } from '@store/common';

function ThresholdSwitch() {
  const dispatch = useDispatch();
  const commonStore = useSelector(commonSelector);
  const thresholdDisabled = commonStore.features[featureNames.DISABLE_THRESHOLD];

  const handleToggleCheck = useCallback(
    (checked) => {
      setTimeout(() => {
        dispatch(setThresholdDisabledStatus(!checked));
      }, 0);
    },
    [dispatch],
  );

  return (
    <Space direction="vertical">
      <Header>Threshold</Header>
      <div>
        <Switch checked={!thresholdDisabled} onChange={handleToggleCheck} />
        <ToggleText>Thresholds</ToggleText>
      </div>
    </Space>
  );
}

export default ThresholdSwitch;
